export class Option {
    public id: number;
    public langs: {es: string};
    public name_lang_code: string;
    public created_at: string;
    public updated_at: string;
    public deleted_at: string;


    constructor() {
        this.id = 0;
        this.langs = {es: ''};
        this.name_lang_code = '';
        this.created_at = '';
        this.updated_at = '';
        this.deleted_at = '';
        
    }
}
